import saleByPaymentMethod from './sale-by-payment-method'
import skuSaleDetailed from './sku-sale-detailed'
import installmentSale from './installment-sale'

export default {
  namespaced: true,
  modules: {
    saleByPaymentMethod,
    skuSaleDetailed,
    installmentSale,
  },
  state: {},
  mutations: {},
  actions: {},
}
